/* Ayudate · Restablecer contraseña del dashboard
   Se llega acá desde el enlace de recuperación de un solo uso que genera
   solicitarRecuperacionPassword() (apps-script.gs), tras tocar "Olvidé mi
   contraseña" en /login: el tutor elige una contraseña nueva con el token
   de la URL (?t=...), y de ahí en más vuelve a entrar por /login como
   siempre. */

import React, { useState } from "react";
import { Marca } from "../componentes/Marca";
import { ESTILOS_MINIMOS } from "../estilos/minimos";
import { api, ErrorApi } from "../api";
import { irA_ruta } from "../lib/rutas";
import { CampoPassword } from "../componentes/CampoPassword";

const MENSAJES_ERROR = {
  TOKEN_INVALIDO: "Este enlace de recuperación no es válido. Revise que lo copió completo.",
  TOKEN_VENCIDO: "Este enlace de recuperación venció. Pida uno nuevo desde \"Olvidé mi contraseña\" en /login.",
  DEMASIADAS_PETICIONES: "Hay mucha gente restableciendo su contraseña en este momento. Pruebe de nuevo en unos segundos.",
};

export function PaginaRestablecerPassword() {
  const token = new URLSearchParams(window.location.search).get("t") || "";
  const [password, setPassword] = useState("");
  const [confirmar, setConfirmar] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [listo, setListo] = useState(false);
  const [error, setError] = useState("");

  const validar = () => {
    if (password.length < 8) return "La contraseña debe tener al menos 8 caracteres.";
    if (password !== confirmar) return "Las contraseñas no coinciden.";
    return "";
  };

  const enviar = async (e) => {
    e.preventDefault();
    const problema = validar();
    if (problema) return setError(problema);

    setEnviando(true); setError("");
    try {
      await api.confirmarRestablecimientoPassword(token, password);
      setListo(true);
    } catch (err) {
      const codigo = err instanceof ErrorApi ? err.codigo : null;
      setError(MENSAJES_ERROR[codigo] || err.message || "No pudimos restablecer su contraseña. Pruebe de nuevo.");
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="v2">
      <style>{ESTILOS_MINIMOS}</style>
      <div className="mini-wrap">
        <div className="logo" style={{ marginBottom: 28 }}><Marca /></div>

        {!token ? (
          <div className="mini-card">
            <h1>Enlace incompleto</h1>
            <p>
              Este enlace no trae el código de recuperación. Revise el correo que le enviamos y abra
              el enlace completo, o pida uno nuevo desde "Olvidé mi contraseña" en /login.
            </p>
            <a className="btn btn-p" href="/login" onClick={(e) => { e.preventDefault(); irA_ruta("/login"); }}>
              Ir a iniciar sesión
            </a>
          </div>
        ) : listo ? (
          <div className="mini-card">
            <h1>Su contraseña ya quedó actualizada</h1>
            <p>Ya puede entrar a su dashboard de tutor con su usuario y la contraseña nueva.</p>
            <a className="btn btn-p" href="/login"
              onClick={(e) => { e.preventDefault(); irA_ruta("/login"); }}>
              Ir a iniciar sesión
            </a>
          </div>
        ) : (
          <form className="mini-card" onSubmit={enviar}>
            <h1>Elija una contraseña nueva</h1>
            <p>Este enlace vence a la hora de haberlo pedido y sirve una sola vez.</p>

            <label className="lb" htmlFor="password">Contraseña nueva</label>
            <CampoPassword id="password" className="in" value={password}
              autoComplete="new-password" onChange={(e) => setPassword(e.target.value)}
              placeholder="Mínimo 8 caracteres" />

            <label className="lb" htmlFor="confirmar">Confirmar contraseña</label>
            <CampoPassword id="confirmar" className="in" value={confirmar}
              autoComplete="new-password" onChange={(e) => setConfirmar(e.target.value)}
              placeholder="Repítala" />

            {error && <div className="error" role="alert">{error}</div>}

            <button className="btn btn-p" style={{ width: "100%", marginTop: 16 }}
              disabled={enviando}>
              {enviando ? "Guardando…" : "Restablecer contraseña"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
